"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var _Constants = require("composer-plugins/plugins/questionAndAnswer/Constants");

var _UIRadioInput = _interopRequireDefault(require("UIComponents/input/UIRadioInput"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var ANSWER_OPTIONS = [_Constants.AnswerTypes.TEXT_ONLY, _Constants.AnswerTypes.QUICK_REPLIES, _Constants.AnswerTypes.PROPERTY_QUICK_REPLIES];

var QuestionTextInput = function QuestionTextInput(_ref) {
  var question = _ref.question,
      _onChange = _ref.onChange;
  return _react.default.createElement("div", {
    className: "m-bottom-3"
  }, _react.default.createElement(_UIFormLabel.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.answerOptions.label"
  })), ANSWER_OPTIONS.map(function (option) {
    return _react.default.createElement(_UIRadioInput.default, {
      key: option,
      checked: option === question.answerType,
      onChange: function onChange() {
        return _onChange(question.setAnswerType(option));
      },
      name: "question-and-answer-type",
      description: _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "composer-plugins.questionAndAnswer.answerOptionsHelpText." + option
      })),
      "data-selenium-test": "question-and-answer-" + option,
      "data-onboarding-id": "question-and-answer-type-radio",
      "data-option-value": option
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.questionAndAnswer.answerOptions." + option
    }));
  }));
};

QuestionTextInput.propTypes = {
  question: _propTypes.default.instanceOf(_QuestionEntityRecord.default).isRequired,
  onChange: _propTypes.default.func.isRequired
};
var _default = QuestionTextInput;
exports.default = _default;
module.exports = exports.default;